import clsx from 'clsx';
import { FC, PropsWithChildren, useMemo } from 'react';
import Style from './builderFieldError.module.scss';
import { ReactComponent as WarningIcon } from 'assets/img/generalBuilder/warning_16.svg';

export type BuilderFieldErrorProps = {
  errors?: string | string[];
  className?: string;
  hideBorder?: boolean;
  hideText?: boolean;
  position?: 'top' | 'bottom';
};

export const BuilderFieldError: FC<PropsWithChildren<BuilderFieldErrorProps>> = ({
  errors,
  className,
  children,
  hideBorder,
  hideText,
  position = 'bottom',
}) => {
  const errorContent = useMemo(() => {
    if (!errors || (Array.isArray(errors) && !errors.length)) {
      return <p className={Style.placeholder}>{'placeholder'}</p>;
    }

    if (Array.isArray(errors)) {
      return errors.map((error, i) => <p key={i}>{error}</p>);
    }

    return <p>{errors}</p>;
  }, [errors]);

  const hasErrors = useMemo(() => (Array.isArray(errors) ? !!errors.length : !!errors), [errors]);

  return (
    <div
      className={clsx(Style.errorContainer, className, {
        [Style.leftBorder]: hasErrors && !hideBorder,
        [Style.reverse]: position === 'top',
      })}
    >
      {children}
      {!hideText && <div className={Style.errors}>{errorContent}</div>}
    </div>
  );
};

export const ErrorSign = () => (
  <div className={Style.iconWrapper}>
    <WarningIcon className={Style.errorIcon} />
  </div>
);
